import { Link } from 'react-router-dom';
import { useI18n } from '@/contexts/I18nContext';
import { PageHead } from '@/components/layout/PageHead';
import { EmptyState } from '@/components/ui/EmptyState';
import { Button } from '@/components/shadcn/button';

export function Forbidden() {
  const { t } = useI18n();
  return (
    <>
      <PageHead title="403" subtitle={t('forbidden')} />
      <EmptyState
        title={t('forbidden')}
        sub={t('forbidden_sub')}
        action={
          <Button variant="outline" size="sm" asChild>
            <Link to="/dashboard">{t('back_to_dashboard')}</Link>
          </Button>
        }
      />
    </>
  );
}
